import "./bootstrap";
import "./sentry.js"

import.meta.glob(["../fonts/**"]);

import tippy from "tippy.js";
import "tippy.js/dist/tippy.css";
import "tippy.js/themes/light.css";

import {
    Chart,
    LineController, DoughnutController, BarController,
    LineElement, PointElement, ArcElement, BarElement,
    LinearScale, CategoryScale,
    Tooltip,
    Legend,
} from 'chart.js';

Chart.register(
    LineController,
    DoughnutController,
    BarController,
    LineElement,
    ArcElement,
    BarElement,
    PointElement,
    LinearScale,
    CategoryScale,
    Tooltip,
    Legend
);

import flatpickr from "flatpickr";
import 'flatpickr/dist/flatpickr.min.css';

import sort from "@alpinejs/sort";
import collapse from "@alpinejs/collapse";

import "./alpineData";
import "./utils";

Alpine.plugin(sort);
Alpine.plugin(collapse);

window.tippy = tippy;

document.addEventListener("livewire:initialized", () => {
    Livewire.hook("element.init", (el, component) =>
        setTimeout(() => tippy("[data-tippy-content]"), 700)
    );
});

document.addEventListener("alpine:init", () => {
    Alpine.directive("tooltip-dataset", (el, { expression }, {cleanup}) => {
        let tooltip = null;
        let observer = null;

        const init = () => {
            if (el?.scrollWidth > el?.offsetWidth) {
                if (!tooltip) {
                    tooltip = tippy(el, {
                        content: el.dataset.tooltip,
                        interactive: true,
                        allowHTML: true,
                        appendTo: document.body,
                    });
                }
            } else if (tooltip) {
                tooltip.destroy();
                tooltip  = null;
            }
        }

        Alpine.nextTick(() => {
            observer = new ResizeObserver(init);
            observer.observe(el);
            init();
        });

        cleanup(() => {
            observer && observer.disconnect();
            tooltip && tooltip.destroy();
        });
    });

    Alpine.directive("tooltip", (el, { expression }) => {
        tippy(el, {
            content: expression,
            interactive: true,
            allowHTML: true,
            appendTo: document.body,
        });
    });
});

const toast = ({ type = "success", message = "" }) => {
    window.Livewire.dispatch("toast::show", { type, message });
};

window.toast = toast;
window.Chart = Chart;
window.flatpickr = flatpickr;
